import { FC } from 'react';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button, Grid, Typography, useTheme } from '@mui/material';

import { navigate, routes } from '@redwoodjs/router';

import HeaderBackground from 'src/assets/images/backgrounds/HeaderBackground.jpg';
import { DEFAULT_BORDER } from 'src/constants';

interface TitleSectionProps {
    serviceId: string | number;
    onCompleteCall?: () => void;
}

const TitleSection: FC<TitleSectionProps> = ({ serviceId, onCompleteCall }) => {
    const theme = useTheme();

    return (
        <Grid
            item
            xs={12}
            container
            sx={{
                ...DEFAULT_BORDER,
                height: '116px',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 20px rgba(38,50,56,0.1)',
                p: '12px 24px',
                alignItems: 'center',
                backgroundImage: `url(${HeaderBackground})`,
            }}
        >
            <Grid item xs={8}>
                <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B', mb: '8px' }}>
                    Check‑in Call Dashboard
                </Typography>
                <Typography sx={{ fontSize: '21px', fontWeight: 400, color: '#F18F34' }}>
                    <span>Service Order ID:</span>&nbsp;
                    <span data-testid="service-order-id">{serviceId}</span>
                </Typography>
            </Grid>

            <Grid item xs={4} display="flex" justifyContent="right" gap={2}>
                <Button
                    variant="npi-primary"
                    sx={{ background: theme.palette.success.main }}
                    onClick={onCompleteCall}
                    isElevationDisabled
                >
                    Complete Call
                </Button>

                <Button
                    startIcon={<ArrowBackIosNewIcon fontSize="small" />}
                    variant="npi-primary"
                    onClick={() => {
                        return navigate(routes.checkInCalls());
                    }}
                    isElevationDisabled
                >
                    Back To Check-in Calls
                </Button>
            </Grid>
        </Grid>
    );
};

export default TitleSection;
